import { render, staticRenderFns } from "./MAN901M01.vue?vue&type=template&id=a71402f4&"
import script from "./MAN901M01.vue?vue&type=script&lang=js&"
export * from "./MAN901M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports